import React from 'react';
import { cn } from '../../lib/utils';

export interface BadgeProps extends React.HTMLAttributes<HTMLDivElement> {
  variant?: 'default' | 'secondary' | 'outline' | 'mechanical' | 'electrical' | 'multicraft' | 'aptitude' | 'success' | 'warning' | 'danger';
}

export function Badge({ className, variant = 'default', ...props }: BadgeProps) {
  const variants = {
    default: 'bg-primary text-primary-foreground',
    secondary: 'bg-secondary text-secondary-foreground border border-border dark:border-slate-700',
    outline: 'border border-border text-foreground',
    mechanical: 'bg-amber-500/15 text-amber-700 dark:text-amber-400 border border-amber-500/30',
    electrical: 'bg-sky-500/15 text-sky-700 dark:text-sky-400 border border-sky-500/30',
    multicraft: 'bg-emerald-500/15 text-emerald-700 dark:text-emerald-400 border border-emerald-500/30',
    aptitude: 'bg-purple-500/15 text-purple-700 dark:text-purple-400 border border-purple-500/30',
    success: 'bg-emerald-500/15 text-emerald-700 dark:text-emerald-400 border border-emerald-500/30',
    warning: 'bg-amber-500/15 text-amber-700 dark:text-amber-400 border border-amber-500/30',
    danger: 'bg-rose-500/15 text-rose-700 dark:text-rose-400 border border-rose-500/30',
  };

  return (
    <div
      className={cn(
        'inline-flex items-center rounded-full px-2.5 py-0.5 text-xs font-semibold uppercase tracking-wider transition-colors select-none',
        variants[variant],
        className
      )}
      {...props}
    />
  );
}
